/**
 * AI Platform
 * Chat API of the hosted agent server (`@convercus/agent-server`). Read a chat as a view: a snapshot from `GET /chats/{chatId}/view`, then its changes from the NDJSON stream `GET /chats/{chatId}/view/stream?after` or the long-poll `GET /chats/{chatId}/view?after&waitMs`. The service sits behind the API gateway, which validates the JWT and forwards identity as plain headers — `program`, `user-id`, `username` and the user\'s `roles`. The view stream is the exception: it is reached without the gateway and verifies the `Authorization: Bearer` token itself. With `AUTH_MODE=mock` (local dev) every request runs as a canned identity and the headers are ignored. Every route but health names the permission it needs and answers 403 to a role that grants none of them: `agent.bi` (ANALYTICS, SUPER_ADMIN) for agents and chats; `agent.config.read`/`agent.config.write` (PROGRAM_MANAGER, SUPER_ADMIN) for the settings; dedicated mode and the spend ledger are SUPER_ADMIN only.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CatalogModelEntry { 
    provider: string;
    id: string;
    label: string;
    /**
     * Which mode offers this entry: \"platform\" entries are selectable in platform mode and in dedicated mode (both run on Convercus\'s models — Claude on Amazon Bedrock, EU regions only; dedicated has no tier of its own), \"byok\" entries in byok mode (run on the program\'s own key). The tiers may overlap, so the same provider/id can appear once per tier — key entries by (provider, id, tier). In byok mode the selectable set is narrowed further, to the providers the program actually holds a key for.
     */
    tier: CatalogModelEntry.TierEnum;
}
export namespace CatalogModelEntry {
    export type TierEnum = 'platform' | 'byok';
    export const TierEnum = {
        Platform: 'platform' as TierEnum,
        Byok: 'byok' as TierEnum
    };
}


